import { render, staticRenderFns } from "./closework.vue?vue&type=template&id=48a25464&"
import script from "./closework.vue?vue&type=script&lang=js&"
export * from "./closework.vue?vue&type=script&lang=js&"
import style0 from "./closework.vue?vue&type=style&index=0&id=48a25464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports